import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { ChangeDetectorRef, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { workflowStatusCssClass, workflowStatusLabel } from '../shared/workflow-status';

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.patrol-dashboard-shell {
  min-height: 100%;
  padding: 16px 18px 28px;
  background: #eef2f1;
  color: var(--ops-text);
  word-break: keep-all;
}

.patrol-console {
  display: grid;
  gap: 12px;
  min-height: calc(100vh - 116px);
}

.patrol-run-identity,
.patrol-run-status {
  display: grid;
  min-width: 0;
}

.patrol-metric-item span,
.patrol-metric-item em,
.patrol-today-head span,
.patrol-today-table-head span,
.patrol-today-status em,
.patrol-panel-head span,
.patrol-table-head span,
.patrol-run-identity span,
.patrol-run-identity em,
.patrol-run-status em,
.patrol-stage-step i,
.patrol-stage-step b {
  color: var(--ops-muted);
  font-size: 11px;
  font-style: normal;
  font-weight: 900;
  line-height: 1.2;
  letter-spacing: 0;
}

.patrol-metric-strip {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border: 1px solid var(--ops-border-strong);
  background: #ffffff;
}

.patrol-metric-item {
  display: grid;
  min-height: 76px;
  align-content: center;
  gap: 5px;
  border-right: 1px solid var(--ops-border);
  padding: 12px 18px;
}

.patrol-metric-item:last-child {
  border-right: 0;
}

.patrol-metric-item strong {
  color: var(--ops-heading);
  font-size: 24px;
  font-weight: 900;
  line-height: 1;
}

.patrol-workspace-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(500px, 0.95fr);
  align-items: stretch;
  gap: 12px;
}

.patrol-today-panel {
  display: flex;
  min-height: 0;
  min-width: 0;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--ops-border-strong);
  background: #ffffff;
}

.patrol-today-head {
  display: flex;
  min-height: 62px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #111714;
  padding: 0 18px;
}

.patrol-today-head div {
  display: flex;
  min-width: 0;
  align-items: baseline;
  gap: 10px;
}

.patrol-today-head strong {
  color: var(--ops-heading);
  font-size: 24px;
  font-weight: 900;
  line-height: 1;
}

.patrol-today-list {
  display: grid;
  align-content: start;
  flex: 1 1 auto;
  grid-auto-rows: auto;
  min-height: 0;
  overflow: hidden;
}

.patrol-today-table-head,
.patrol-today-row {
  display: grid;
  grid-template-columns: minmax(128px, 0.82fr) minmax(190px, 1.18fr) minmax(144px, 0.72fr) 96px;
  column-gap: 14px;
  align-items: center;
}

.patrol-today-table-head {
  min-height: 36px;
  border-bottom: 1px solid var(--ops-border);
  background: #f5f7f6;
  padding: 0 16px;
}

.patrol-today-row {
  min-height: 82px;
  border-bottom: 1px solid var(--ops-border);
  border-left: 4px solid #9ca3af;
  padding: 10px 14px 10px 10px;
}

.patrol-today-row:last-child {
  border-bottom: 0;
}

.patrol-today-row:hover {
  background: #f8faf9;
}

.patrol-today-row.is-active {
  border-left-color: #2f7f62;
}

.patrol-today-row.is-warning {
  border-left-color: #c47a00;
}

.patrol-today-row.is-danger {
  border-left-color: #c2413d;
}

.patrol-today-row.is-report {
  border-left-color: #2770a8;
}

.patrol-today-row.is-clear {
  border-left-color: #6b7280;
}

.patrol-today-row.is-work-patrol-setup-required {
  border-left-color: #c47a00;
}

.patrol-today-row.is-work-patrol-scheduled {
  border-left-color: #7b8580;
}

.patrol-today-row.is-work-patrol-running {
  border-left-color: #2770a8;
}

.patrol-today-row.is-work-patrol-completed {
  border-left-color: #0f766e;
}

.patrol-today-row.is-work-ai-required {
  border-left-color: #1d4ed8;
}

.patrol-today-row.is-work-recapture-requested {
  border-left-color: #c47a00;
}

.patrol-today-row.is-work-field-check-required {
  border-left-color: #c2413d;
}

.patrol-today-row.is-work-report-required {
  border-left-color: #0e7490;
}

.patrol-today-row.is-work-report-generated {
  border-left-color: #2f7f62;
}

.patrol-today-name,
.patrol-today-target,
.patrol-today-status {
  display: grid;
  min-width: 0;
  gap: 6px;
}

.patrol-today-row > .patrol-action {
  grid-area: auto;
  justify-self: start;
}

.patrol-today-name strong,
.patrol-today-target strong {
  overflow: hidden;
  color: var(--ops-heading);
  font-size: 14px;
  font-weight: 900;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.patrol-today-name strong {
  font-size: 15px;
}

.patrol-today-status mark {
  display: inline-flex;
  justify-self: start;
  min-height: 28px;
  align-items: center;
  border: 1px solid var(--ops-border-strong);
  background: #f8faf9;
  color: var(--ops-heading);
  padding: 0 9px;
  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;
}

.patrol-today-row.is-active .patrol-today-status mark {
  border-color: #a9d2bf;
  background: #eef8f2;
  color: #17663c;
}

.patrol-today-row.is-warning .patrol-today-status mark,
.patrol-today-row.is-danger .patrol-today-status mark {
  border-color: #e7ba61;
  background: #fff7e6;
  color: #875400;
}

.patrol-today-row.is-report .patrol-today-status mark {
  border-color: #a9cce8;
  background: #eef6fd;
  color: #185a91;
}

.patrol-today-row.is-work-patrol-setup-required .patrol-today-status mark,
.patrol-today-row.is-work-recapture-requested .patrol-today-status mark {
  border-color: #fde68a;
  background: #fffbeb;
  color: #92400e;
}

.patrol-today-row.is-work-patrol-scheduled .patrol-today-status mark {
  border-color: #d4d8d5;
  background: #f7faf8;
  color: #46534c;
}

.patrol-today-row.is-work-patrol-running .patrol-today-status mark {
  border-color: #bae6fd;
  background: #f0f9ff;
  color: #0369a1;
}

.patrol-today-row.is-work-patrol-completed .patrol-today-status mark {
  border-color: #99f6e4;
  background: #f0fdfa;
  color: #0f766e;
}

.patrol-today-row.is-work-ai-required .patrol-today-status mark {
  border-color: #bfdbfe;
  background: #eff6ff;
  color: #1d4ed8;
}

.patrol-today-row.is-work-field-check-required .patrol-today-status mark {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.patrol-today-row.is-work-report-required .patrol-today-status mark {
  border-color: #a5f3fc;
  background: #ecfeff;
  color: #0e7490;
}

.patrol-today-row.is-work-report-generated .patrol-today-status mark {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #15803d;
}

.patrol-calendar-panel {
  min-width: 0;
  height: 100%;
  border: 1px solid var(--ops-border-strong);
  background: #ffffff;
}

.patrol-calendar-head {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  min-height: 60px;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #111714;
  padding: 10px 12px;
}

.patrol-calendar-label {
  color: var(--ops-muted);
  white-space: nowrap;
}

.patrol-calendar-weekdays span,
.patrol-calendar-event span,
.patrol-calendar-event em,
.patrol-calendar-unscheduled span {
  color: var(--ops-muted);
  font-size: 11px;
  font-style: normal;
  font-weight: 900;
  line-height: 1.2;
}

.patrol-calendar-month-control {
  display: inline-grid;
  grid-column: 2;
  grid-template-columns: 28px minmax(94px, auto) 28px;
  align-items: center;
  justify-self: end;
  gap: 6px;
}

.patrol-calendar-month-control strong {
  color: var(--ops-heading);
  font-size: 16px;
  font-weight: 900;
  line-height: 1.15;
  text-align: center;
  white-space: nowrap;
}

.patrol-calendar-arrow {
  display: inline-flex;
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--ops-border-strong);
  background: #ffffff;
  color: var(--ops-heading);
  cursor: pointer;
  font: inherit;
  font-size: 18px;
  font-weight: 900;
  line-height: 1;
}

.patrol-calendar-arrow:hover {
  background: #f5f7f6;
}

.patrol-calendar {
  overflow-x: visible;
  overflow-y: visible;
  padding-bottom: 12px;
}

.patrol-calendar-weekdays,
.patrol-calendar-days {
  display: grid;
  min-width: 0;
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

.patrol-calendar-weekdays {
  border-bottom: 1px solid var(--ops-border);
  background: #f5f7f6;
}

.patrol-calendar-weekdays span {
  min-height: 30px;
  border-right: 1px solid var(--ops-border);
  padding: 9px 4px 0;
  text-align: center;
}

.patrol-calendar-weekdays span:last-child {
  border-right: 0;
}

.patrol-calendar-day {
  position: relative;
  display: grid;
  min-height: 92px;
  align-content: start;
  gap: 5px;
  border-right: 1px solid #d6dfda;
  border-bottom: 1px solid #d6dfda;
  background: #ffffff;
  padding: 6px;
}

.patrol-calendar-day:nth-child(7n) {
  border-right: 0;
}

.patrol-calendar-day.is-muted {
  background: #f7f9f8;
  color: #a4aaa7;
}

.patrol-calendar-day.is-empty {
  background: #f7f9f8;
}

.patrol-calendar-day.has-events {
  background: #fbfcfb;
}

.patrol-calendar-date {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 22px;
}

.patrol-calendar-date span {
  display: inline-flex;
  width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;
  color: var(--ops-heading);
  font-size: 12px;
  font-weight: 900;
}

.patrol-calendar-date em {
  color: #17663c;
  font-size: 10px;
  font-style: normal;
  font-weight: 900;
}

.patrol-calendar-day.is-today .patrol-calendar-date span {
  background: #111714;
  color: #ffffff;
}

.patrol-calendar-events {
  display: grid;
  gap: 5px;
}

.patrol-calendar-event {
  display: grid;
  min-width: 0;
  gap: 1px;
  border: 1px solid #c9d2cd;
  border-left: 2px solid #2f7f62;
  background: #f4faf6;
  color: var(--ops-text);
  padding: 5px;
  text-decoration: none;
}

.patrol-calendar-event:hover {
  background: #edf7f1;
}

.patrol-calendar-event.is-on-demand {
  border-left-color: #c47a00;
  background: #fff8e9;
}

.patrol-calendar-event.is-setup {
  border-left-color: #c47a00;
  background: #fff7e6;
}

.patrol-calendar-event strong,
.patrol-calendar-event span,
.patrol-calendar-event em {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.patrol-calendar-event strong {
  color: var(--ops-heading);
  font-size: 11px;
  font-weight: 900;
  line-height: 1.2;
}

.patrol-calendar-events .patrol-calendar-event span,
.patrol-calendar-events .patrol-calendar-event em {
  display: none;
}

.patrol-calendar-more-wrap {
  position: relative;
  display: flex;
  justify-content: center;
  min-height: 24px;
}

.patrol-calendar-more {
  display: inline-flex;
  min-width: 48px;
  height: 24px;
  align-items: center;
  justify-content: center;
  gap: 3px;
  border: 1px solid var(--ops-border-strong);
  background: #ffffff;
  color: var(--ops-heading);
  cursor: pointer;
  font: inherit;
  font-size: 11px;
  font-weight: 900;
  line-height: 1;
}

.patrol-calendar-more span,
.patrol-calendar-more b {
  display: inline-flex;
  align-items: center;
  line-height: 1;
}

.patrol-calendar-more.is-open,
.patrol-calendar-more:hover {
  background: #111714;
  color: #ffffff;
}

.patrol-calendar-popover {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  z-index: 30;
  display: grid;
  width: min(260px, 100vw - 48px);
  max-height: 240px;
  gap: 6px;
  overflow-y: auto;
  border: 1px solid #111714;
  background: #ffffff;
  box-shadow: 0 14px 28px rgba(17, 23, 20, 0.18);
  padding: 10px;
  transform: translateX(-50%);
}

.patrol-calendar-popover::before {
  position: absolute;
  top: -7px;
  left: 50%;
  width: 12px;
  height: 12px;
  border-top: 1px solid #111714;
  border-left: 1px solid #111714;
  background: #ffffff;
  content: "";
  transform: translateX(-50%) rotate(45deg);
}

.patrol-calendar-popover .patrol-calendar-event {
  background: #ffffff;
}

.patrol-calendar-popover .patrol-calendar-event em {
  display: block;
}

.patrol-calendar-unscheduled {
  display: flex;
  min-height: 44px;
  align-items: center;
  gap: 8px;
  border-top: 1px solid var(--ops-border);
  background: #f8faf9;
  padding: 0 14px;
}

.patrol-calendar-unscheduled strong {
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  border: 1px solid #e7ba61;
  background: #fff7e6;
  color: #875400;
  padding: 0 8px;
  font-size: 11px;
  font-weight: 900;
}

.patrol-calendar-empty {
  display: grid;
  min-height: 220px;
  place-items: center;
  align-content: center;
  gap: 10px;
  color: var(--ops-muted);
  padding: 24px;
  text-align: center;
}

.patrol-calendar-empty strong {
  color: var(--ops-heading);
  font-size: 17px;
  font-weight: 900;
}

.patrol-calendar-empty span {
  font-size: 13px;
  font-weight: 800;
}

.patrol-console-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  min-height: 0;
  align-items: stretch;
  gap: 12px;
}

.patrol-board-panel {
  display: flex;
  min-height: 0;
  min-width: 0;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--ops-border-strong);
  background: #ffffff;
}

.patrol-panel-head {
  display: flex;
  min-height: 52px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #111714;
  padding: 0 16px;
}

.patrol-panel-head strong {
  color: var(--ops-heading);
  font-size: 13px;
  font-weight: 900;
  white-space: nowrap;
}

.patrol-table {
  display: grid;
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
}

.patrol-table-head,
.patrol-run-row {
  display: grid;
  grid-template-columns: minmax(230px, 1.05fr) minmax(340px, 1.35fr) minmax(154px, 0.72fr) 104px;
  column-gap: 16px;
  align-items: center;
}

.patrol-table-head {
  min-height: 38px;
  border-bottom: 1px solid var(--ops-border);
  background: #f5f7f6;
  padding: 0 16px;
}

.patrol-run-row {
  min-height: 92px;
  border-bottom: 1px solid var(--ops-border);
  border-left: 4px solid #9ca3af;
  padding: 14px 16px 14px 12px;
}

.patrol-run-row:last-child {
  border-bottom: 0;
}

.patrol-run-row:hover {
  background: #f8faf9;
}

.patrol-run-row.is-active {
  border-left-color: #2f7f62;
}

.patrol-run-row.is-warning {
  border-left-color: #c47a00;
}

.patrol-run-row.is-danger {
  border-left-color: #c2413d;
}

.patrol-run-row.is-report {
  border-left-color: #2770a8;
}

.patrol-run-row.is-clear {
  border-left-color: #6b7280;
}

.patrol-run-row.is-work-patrol-setup-required {
  border-left-color: #c47a00;
}

.patrol-run-row.is-work-patrol-scheduled {
  border-left-color: #7b8580;
}

.patrol-run-row.is-work-patrol-running {
  border-left-color: #2770a8;
}

.patrol-run-row.is-work-patrol-completed {
  border-left-color: #0f766e;
}

.patrol-run-row.is-work-ai-required {
  border-left-color: #1d4ed8;
}

.patrol-run-row.is-work-recapture-requested {
  border-left-color: #c47a00;
}

.patrol-run-row.is-work-field-check-required {
  border-left-color: #c2413d;
}

.patrol-run-row.is-work-report-required {
  border-left-color: #0e7490;
}

.patrol-run-row.is-work-report-generated {
  border-left-color: #2f7f62;
}

.patrol-run-identity {
  gap: 5px;
}

.patrol-run-identity strong {
  overflow: hidden;
  color: var(--ops-heading);
  font-size: 15px;
  font-weight: 900;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.patrol-run-identity span,
.patrol-run-identity em,
.patrol-run-status em {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.patrol-stage-track {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.patrol-stage-step {
  display: grid;
  min-width: 0;
  gap: 5px;
  border-top: 3px solid #cbd5d1;
  padding-top: 8px;
}

.patrol-stage-step.is-done {
  border-top-color: #2f7f62;
}

.patrol-stage-step.is-current {
  border-top-color: #2770a8;
}

.patrol-stage-step.is-warning {
  border-top-color: #c47a00;
}

.patrol-stage-step.is-waiting {
  border-top-color: #cbd5d1;
}

.patrol-stage-step i,
.patrol-stage-step b {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.patrol-stage-step b {
  color: var(--ops-heading);
  font-size: 12px;
}

.patrol-run-status {
  gap: 7px;
}

.patrol-run-status mark {
  display: inline-flex;
  justify-self: start;
  min-height: 28px;
  align-items: center;
  border: 1px solid var(--ops-border-strong);
  background: #f8faf9;
  color: var(--ops-heading);
  padding: 0 9px;
  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;
}

.patrol-run-row.is-active .patrol-run-status mark {
  border-color: #a9d2bf;
  background: #eef8f2;
  color: #17663c;
}

.patrol-run-row.is-warning .patrol-run-status mark,
.patrol-run-row.is-danger .patrol-run-status mark {
  border-color: #e7ba61;
  background: #fff7e6;
  color: #875400;
}

.patrol-run-row.is-report .patrol-run-status mark {
  border-color: #a9cce8;
  background: #eef6fd;
  color: #185a91;
}

.patrol-run-row.is-work-patrol-setup-required .patrol-run-status mark,
.patrol-run-row.is-work-recapture-requested .patrol-run-status mark {
  border-color: #fde68a;
  background: #fffbeb;
  color: #92400e;
}

.patrol-run-row.is-work-patrol-scheduled .patrol-run-status mark {
  border-color: #d4d8d5;
  background: #f7faf8;
  color: #46534c;
}

.patrol-run-row.is-work-patrol-running .patrol-run-status mark {
  border-color: #bae6fd;
  background: #f0f9ff;
  color: #0369a1;
}

.patrol-run-row.is-work-patrol-completed .patrol-run-status mark {
  border-color: #99f6e4;
  background: #f0fdfa;
  color: #0f766e;
}

.patrol-run-row.is-work-ai-required .patrol-run-status mark {
  border-color: #bfdbfe;
  background: #eff6ff;
  color: #1d4ed8;
}

.patrol-run-row.is-work-field-check-required .patrol-run-status mark {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.patrol-run-row.is-work-report-required .patrol-run-status mark {
  border-color: #a5f3fc;
  background: #ecfeff;
  color: #0e7490;
}

.patrol-run-row.is-work-report-generated .patrol-run-status mark {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #15803d;
}

.patrol-action {
  display: inline-flex;
  min-width: 86px;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  border: 1px solid #111714;
  background: #111714;
  color: #ffffff;
  padding: 0 11px;
  font-size: 12px;
  font-weight: 900;
  line-height: 1.2;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
}

.patrol-action:hover {
  background: #243129;
}

.patrol-pagination {
  display: flex;
  flex: 0 0 auto;
  min-height: 48px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-top: 1px solid var(--ops-border);
  background: #f8faf9;
  padding: 8px 12px;
}

.patrol-pagination-pages {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px;
}

.patrol-page-arrow,
.patrol-page-number {
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--ops-border-strong);
  background: #ffffff;
  color: var(--ops-heading);
  cursor: pointer;
  font: inherit;
  font-size: 12px;
  font-weight: 900;
  line-height: 1;
}

.patrol-page-arrow:hover:not(:disabled),
.patrol-page-number:hover,
.patrol-page-number.is-active {
  background: #111714;
  color: #ffffff;
}

.patrol-page-arrow:disabled {
  cursor: default;
  opacity: 0.35;
}

.patrol-empty-state {
  display: grid;
  min-height: 220px;
  place-items: center;
  align-content: center;
  gap: 10px;
  color: var(--ops-muted);
  padding: 24px;
  text-align: center;
}

.patrol-empty-state strong {
  color: var(--ops-heading);
  font-size: 17px;
  font-weight: 900;
}

.patrol-empty-state span {
  font-size: 13px;
  font-weight: 800;
}

.patrol-alert {
  margin-bottom: 12px;
  border: 1px solid #f0c36d;
  background: #fff7e6;
  color: #875400;
  padding: 10px 12px;
  font-size: 13px;
  font-weight: 900;
}

@media (min-width: 1181px) {
  .patrol-workspace-grid .patrol-calendar-head {
    grid-template-columns: auto minmax(0, 1fr);
    min-height: 60px;
    align-items: center;
  }
  .patrol-workspace-grid .patrol-calendar-month-control {
    justify-self: end;
  }
  .patrol-workspace-grid .patrol-table-head {
    display: none;
  }
  .patrol-workspace-grid .patrol-table {
    align-content: start;
    grid-auto-rows: auto;
  }
  .patrol-workspace-grid .patrol-run-row {
    grid-template-areas: "identity action" "stages stages" "status status";
    grid-template-columns: minmax(0, 1fr) auto;
    min-height: 0;
    align-content: center;
    row-gap: 10px;
    column-gap: 12px;
    padding: 12px 14px 12px 10px;
  }
  .patrol-workspace-grid .patrol-run-identity {
    grid-area: identity;
  }
  .patrol-workspace-grid .patrol-stage-track {
    grid-area: stages;
  }
  .patrol-workspace-grid .patrol-run-status {
    grid-area: status;
    grid-template-columns: auto minmax(0, 1fr);
    align-items: center;
    column-gap: 8px;
  }
  .patrol-workspace-grid .patrol-run-row .patrol-action {
    grid-area: action;
    width: auto;
    min-width: 76px;
  }
}
@media (max-width: 1180px) {
  .patrol-workspace-grid {
    align-items: start;
    grid-template-columns: 1fr;
  }
}
@media (max-width: 900px) {
  .patrol-dashboard-shell {
    padding: 12px;
  }
  .patrol-today-panel {
    min-height: 0;
  }
  .patrol-today-head {
    min-height: 64px;
  }
  .patrol-today-head div {
    flex-wrap: wrap;
    row-gap: 4px;
  }
  .patrol-today-table-head {
    display: none;
  }
  .patrol-today-row {
    grid-template-areas: "name action" "target target" "status status";
    grid-template-columns: minmax(0, 1fr) auto;
    min-height: 0;
    row-gap: 10px;
    column-gap: 12px;
    padding: 14px;
  }
  .patrol-today-name {
    grid-area: name;
  }
  .patrol-today-target {
    grid-area: target;
  }
  .patrol-today-status {
    grid-area: status;
    grid-template-columns: auto minmax(0, 1fr);
    align-items: center;
    column-gap: 8px;
  }
  .patrol-today-row .patrol-action {
    grid-area: action;
  }
  .patrol-metric-strip {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .patrol-metric-item:nth-child(2n) {
    border-right: 0;
  }
  .patrol-calendar-head {
    grid-template-columns: 1fr;
  }
  .patrol-calendar-month-control {
    grid-column: auto;
    justify-self: center;
  }
  .patrol-table-head {
    display: none;
  }
  .patrol-run-row {
    grid-template-columns: 1fr;
    row-gap: 14px;
    min-height: 0;
    padding: 14px;
  }
  .patrol-action {
    width: 100%;
  }
}
@media (max-width: 560px) {
  .patrol-metric-strip,
  .patrol-stage-track {
    grid-template-columns: 1fr;
  }
  .patrol-today-row {
    grid-template-areas: "name" "target" "status" "action";
    grid-template-columns: 1fr;
  }
  .patrol-today-row .patrol-action {
    width: 100%;
  }
  .patrol-today-status {
    grid-template-columns: 1fr;
  }
  .patrol-metric-item,
  .patrol-metric-item:nth-child(2n) {
    border-right: 0;
    border-bottom: 1px solid var(--ops-border);
  }
  .patrol-metric-item:last-child {
    border-bottom: 0;
  }
}`],
})
export class PageDashboardComponent implements OnInit {
    public loadMessage: string = '';

    public patrolRuns: any[] = [];
    public summaryStats: any[] = [];
    public openCalendarOverflowDate: string = '';
    public todayPage: number = 1;
    public todayPageSize: number = 5;
    public patrolPage: number = 1;
    public patrolPageSize: number = 5;
    public patrolCalendar: any = {
        monthLabel: '',
        caption: '',
        weekdays: ['일', '월', '화', '수', '목', '금', '토'],
        days: [],
        unscheduled: []
    };
    public selectedCalendarMonth: Date = new Date(new Date().getFullYear(), new Date().getMonth(), 1);

    constructor(@Inject( Service)         public service: Service,@Inject( ChangeDetectorRef    )         public ref: ChangeDetectorRef    ) { }

    public async ngOnInit() {
        await this.service.init(this);
        await this.service.auth.allow('/access');
        this.renderNow();
        await this.loadDashboard();
    }

    public async loadDashboard() {
        this.loadMessage = '';
        try {
            const response: any = await wiz.call('load', {}, { timeout: 15000 });
            const { code, data } = response || {};
            if (code === 200 && data) {
                this.applyDashboard(data);
            } else {
                this.applyFallbackDashboard();
            }
        } catch (error) {
            this.applyFallbackDashboard();
        }
        this.renderNow();
        await this.service.render();
    }

    public applyDashboard(data: any) {
        const rawRuns = data && Array.isArray(data.patrolRuns) && data.patrolRuns.length
            ? data.patrolRuns
            : this.buildRunsFromLegacy(data || {});
        this.patrolRuns = this.withDistributedSamplePatrolPlans(this.normalizeRuns(rawRuns));
        this.openCalendarOverflowDate = '';
        this.todayPage = 1;
        this.patrolPage = 1;
        this.normalizePatrolPage();
        this.patrolCalendar = this.buildCalendarFromRuns(this.patrolRuns);
        this.syncPatrolPageSizeToCalendar();
        this.normalizeTodayPage();
        this.rebuildOverview();
    }

    public applyFallbackDashboard() {
        this.loadMessage = '';
        this.patrolRuns = this.normalizeRuns([
            {
                code: 'SETUP-READY',
                title: '순찰 정보 등록',
                village: '운영 준비',
                owner: '운영 담당자',
                statusType: 'setup',
                statusLabel: workflowStatusLabel('setup'),
                summary: '순찰 기준을 먼저 등록해야 합니다.',
                actionLabel: '정보 등록',
                actionLink: '/villages',
                steps: [
                    { label: '설정', status: workflowStatusLabel('setup'), state: 'warning' },
                    { label: '순찰', status: workflowStatusLabel('assigned'), state: 'waiting' },
                    { label: 'AI', status: workflowStatusLabel('ai'), state: 'waiting' },
                    { label: '보고', status: workflowStatusLabel('report'), state: 'waiting' }
                ]
            }
        ]);
        this.patrolRuns = this.withDistributedSamplePatrolPlans(this.patrolRuns);
        this.openCalendarOverflowDate = '';
        this.todayPage = 1;
        this.patrolPage = 1;
        this.normalizePatrolPage();
        this.patrolCalendar = this.buildCalendarFromRuns(this.patrolRuns);
        this.syncPatrolPageSizeToCalendar();
        this.normalizeTodayPage();
        this.rebuildOverview();
    }

    private withDistributedSamplePatrolPlans(runs: any[]) {
        const targetCount = 7;
        const normalizedRuns = Array.isArray(runs) ? runs : [];
        const scheduledCount = this.monthScheduledActionableCount(normalizedRuns);
        if (scheduledCount >= targetCount) return normalizedRuns;

        const neededCount = targetCount - scheduledCount;
        const weekdayLoad = this.monthWeekdayLoad(normalizedRuns);
        const existingCodes = new Set(normalizedRuns.map((run) => String(run && run.code || '')));
        const candidates = this.normalizeRuns(this.distributedSamplePatrolPlans())
            .filter((run) => !existingCodes.has(String(run.code || '')))
            .sort((a, b) => {
                const aWeekday = Number(a.sampleWeekday || 0);
                const bWeekday = Number(b.sampleWeekday || 0);
                const loadDiff = (weekdayLoad[aWeekday] || 0) - (weekdayLoad[bWeekday] || 0);
                if (loadDiff !== 0) return loadDiff;
                return Number(a.sampleOrder || 0) - Number(b.sampleOrder || 0);
            });
        const samples: any[] = [];
        candidates.forEach((run) => {
            if (samples.length >= neededCount) return;
            samples.push(run);
            const weekday = Number(run.sampleWeekday || 0);
            weekdayLoad[weekday] = (weekdayLoad[weekday] || 0) + 1;
        });
        return [...normalizedRuns, ...samples];
    }

    private monthScheduledActionableCount(runs: any[]) {
        const now = new Date();
        const calendarMonth = this.selectedCalendarMonth || new Date(now.getFullYear(), now.getMonth(), 1);
        const firstDay = new Date(calendarMonth.getFullYear(), calendarMonth.getMonth(), 1);
        const daysInMonth = new Date(calendarMonth.getFullYear(), calendarMonth.getMonth() + 1, 0).getDate();
        return (runs || []).filter((run, index) => {
            if (!this.isActionablePatrolRun(run)) return false;
            const cycle = this.normalizeCopy(run?.cycle || this.defaultCycleForRun(run, index));
            return this.runCalendarDates(run, firstDay, daysInMonth, cycle, index).length > 0;
        }).length;
    }

    private monthWeekdayLoad(runs: any[]) {
        const now = new Date();
        const calendarMonth = this.selectedCalendarMonth || new Date(now.getFullYear(), now.getMonth(), 1);
        const firstDay = new Date(calendarMonth.getFullYear(), calendarMonth.getMonth(), 1);
        const daysInMonth = new Date(calendarMonth.getFullYear(), calendarMonth.getMonth() + 1, 0).getDate();
        const load = [0, 0, 0, 0, 0, 0, 0];
        (runs || []).forEach((run, index) => {
            if (!this.isActionablePatrolRun(run)) return;
            const cycle = this.normalizeCopy(run?.cycle || this.defaultCycleForRun(run, index));
            this.runCalendarDates(run, firstDay, daysInMonth, cycle, index).forEach((date) => {
                const weekday = (date.getDay() + 6) % 7;
                load[weekday] += 1;
            });
        });
        return load;
    }

    private distributedSamplePatrolPlans() {
        const specs = [
            { code: 'SCEN-MON-01', weekday: 0, time: '08:40', missionCode: 'TPL-2026-SN-01', templateId: 'ops-saneri-regular', title: '사내리 정기 순찰', village: '사내리', owner: '자원보전 업무팀', summary: 'P-03 지붕선 촬영' },
            { code: 'SCEN-TUE-01', weekday: 1, time: '09:30', missionCode: 'TPL-2026-SG-02', templateId: 'ops-samgari-lifezone', title: '삼가리 농경지 순찰', village: '삼가리 농경지', owner: '드론 운용 담당', summary: 'P-03 비가림막 촬영' },
            { code: 'SCEN-WED-01', weekday: 2, time: '10:20', missionCode: 'TPL-2026-BJ-03', templateId: 'ops-beopjusa-entry', title: '법주사지구 진입부 점검', village: '법주사지구', owner: '공원관리 현장팀', summary: 'P-02 교량 하부 촬영' },
            { code: 'SCEN-THU-01', weekday: 3, time: '11:10', missionCode: 'TPL-2026-SN-01', templateId: 'ops-saneri-regular', title: '사내리 정기 순찰', village: '사내리', owner: '탐방시설 담당', summary: 'P-02 탐방로 촬영' },
            { code: 'SCEN-FRI-01', weekday: 4, time: '09:50', missionCode: 'TPL-2026-SG-02', templateId: 'ops-samgari-lifezone', title: '삼가리 농경지 순찰', village: '삼가리', owner: '드론 운용 담당', summary: 'P-04 진입로 촬영' },
            { code: 'SCEN-SAT-01', weekday: 5, time: '12:30', missionCode: 'TPL-2026-BJ-03', templateId: 'ops-beopjusa-entry', title: '법주사지구 진입부 점검', village: '법주사지구', owner: '공원관리 현장팀', summary: 'P-01 탐방로 하단 촬영' },
            { code: 'SCEN-SUN-01', weekday: 6, time: '10:45', missionCode: 'TPL-2026-SN-01', templateId: 'ops-saneri-regular', title: '사내리 정기 순찰', village: '사내리', owner: '자원보전 업무팀', summary: 'P-03 보호구역 외곽 촬영' }
        ];

        return specs.map((item, index) => ({
            ...item,
            statusType: 'assigned',
            statusLabel: workflowStatusLabel('assigned'),
            actionLabel: '순찰 실행',
            actionLink: '/missions',
            due: this.sampleDueLabel(item.weekday, item.time),
            scheduledDate: this.weekdayDateKey(item.weekday),
            sampleWeekday: item.weekday,
            sampleOrder: index,
            cycle: '매주',
            toneClass: 'is-active',
            sourceType: 'demo'
        }));
    }

    private weekdayDateKey(weekdayIndex: number) {
        const today = new Date();
        const currentWeekday = (today.getDay() + 6) % 7;
        const target = new Date(today);
        target.setDate(today.getDate() + weekdayIndex - currentWeekday);
        target.setHours(0, 0, 0, 0);
        return this.dateKey(target);
    }

    private sampleDueLabel(weekdayIndex: number, time: string) {
        const target = this.weekdayDateKey(weekdayIndex);
        if (target === this.dateKey(new Date())) return `오늘 ${time}`;
        const weekdays = ['월', '화', '수', '목', '금', '토', '일'];
        return `${weekdays[weekdayIndex]} ${time}`;
    }

    public async moveCalendarMonth(offset: number) {
        const base = this.selectedCalendarMonth || new Date();
        this.selectedCalendarMonth = new Date(base.getFullYear(), base.getMonth() + offset, 1);
        this.openCalendarOverflowDate = '';
        this.patrolCalendar = this.buildCalendarFromRuns(this.patrolRuns);
        this.syncPatrolPageSizeToCalendar();
        this.renderNow();
        await this.service.render();
    }

    public async toggleCalendarOverflow(day: any) {
        if (!day || !day.date || !Array.isArray(day.overflowEvents) || !day.overflowEvents.length) return;
        this.openCalendarOverflowDate = this.openCalendarOverflowDate === day.date ? '' : day.date;
        this.renderNow();
        await this.service.render();
    }

    public todayActionablePatrolRuns() {
        return this.patrolRuns.filter((run, index) => this.isTodayScheduledRun(run, index) && this.isActionablePatrolRun(run));
    }

    public todayWorkItems() {
        const items = (Array.isArray(this.patrolRuns) ? this.patrolRuns : []).reduce((rows: any[], run: any, index: number) => {
            const statusType = this.normalizeStatusType(run?.statusType || 'assigned');
            const isPatrolWork = ['assigned', 'patrol'].indexOf(statusType) >= 0
                && String(run?.actionLink || '').indexOf('/missions') === 0
                && (this.isTodayScheduledRun(run, index) || this.isDueTodayRun(run));
            const isAiWork = ['ai', 'recapture', 'field'].indexOf(statusType) >= 0;
            const isReportWork = statusType === 'report';
            if (!isPatrolWork && !isAiWork && !isReportWork) return rows;

            rows.push({
                workName: this.workNameForStatus(statusType),
                target: this.workTargetForRun(run, statusType),
                statusLabel: this.normalizeCopy(run?.statusLabel || this.statusLabel(statusType)),
                due: this.normalizeCopy(run?.due || run?.summary || '오늘'),
                actionLabel: this.normalizeCopy(run?.actionLabel || this.actionLabel(statusType)),
                actionLink: run?.actionLink || this.actionLink(statusType),
                queryParams: this.actionQueryParams(run),
                toneClass: run?.toneClass || this.toneClass(statusType),
                sortOrder: this.workSortOrder(statusType),
                originalIndex: index
            });
            return rows;
        }, []);

        return items.sort((a, b) => {
            if (a.sortOrder !== b.sortOrder) return a.sortOrder - b.sortOrder;
            return a.originalIndex - b.originalIndex;
        });
    }

    public pagedTodayWorkItems() {
        const items = this.todayWorkItems();
        const page = Math.max(1, Math.min(this.todayWorkPageCount(), this.todayPage));
        const start = (page - 1) * this.todayPageSize;
        return items.slice(start, start + this.todayPageSize);
    }

    public todayWorkPageCount() {
        return Math.max(1, Math.ceil(this.todayWorkItems().length / this.todayPageSize));
    }

    public todayWorkPageNumbers() {
        const count = this.todayWorkPageCount();
        return Array.from({ length: count }, (_, index) => index + 1);
    }

    public async setTodayWorkPage(page: any) {
        const numericPage = Number(page) || 1;
        this.todayPage = Math.max(1, Math.min(this.todayWorkPageCount(), numericPage));
        this.renderNow();
        await this.service.render();
    }

    public async moveTodayWorkPage(offset: number) {
        await this.setTodayWorkPage(this.todayPage + offset);
    }

    public pagedPatrolRuns() {
        const runs = this.todayActionablePatrolRuns();
        const page = Math.max(1, Math.min(this.patrolPageCount(), this.patrolPage));
        const start = (page - 1) * this.patrolPageSize;
        return runs.slice(start, start + this.patrolPageSize);
    }

    public patrolPageCount() {
        return Math.max(1, Math.ceil(this.todayActionablePatrolRuns().length / this.patrolPageSize));
    }

    public patrolPageNumbers() {
        const count = this.patrolPageCount();
        return Array.from({ length: count }, (_, index) => index + 1);
    }

    public async setPatrolPage(page: any) {
        const numericPage = Number(page) || 1;
        this.patrolPage = Math.max(1, Math.min(this.patrolPageCount(), numericPage));
        this.renderNow();
        await this.service.render();
    }

    public async movePatrolPage(offset: number) {
        await this.setPatrolPage(this.patrolPage + offset);
    }

    private currentMonthLabel(date?: Date) {
        const target = date || this.selectedCalendarMonth || new Date();
        return `${target.getFullYear()}년 ${target.getMonth() + 1}월`;
    }

    private buildCalendarFromRuns(runs: any[]) {
        const now = new Date();
        const calendarMonth = this.selectedCalendarMonth || new Date(now.getFullYear(), now.getMonth(), 1);
        const firstDay = new Date(calendarMonth.getFullYear(), calendarMonth.getMonth(), 1);
        const daysInMonth = new Date(calendarMonth.getFullYear(), calendarMonth.getMonth() + 1, 0).getDate();
        const leadingBlankDays = firstDay.getDay();
        const gridLength = Math.ceil((leadingBlankDays + daysInMonth) / 7) * 7;
        const eventsByDate: any = {};
        const unscheduled: any[] = [];

        (Array.isArray(runs) ? runs : []).forEach((run, index) => {
            if (!this.isActionablePatrolRun(run)) return;
            const cycle = this.normalizeCopy(run.cycle || this.defaultCycleForRun(run, index));
            const event = {
                code: run.code || '',
                title: this.normalizeCopy(run.title || '순찰 기준 미지정'),
                village: this.normalizeCopy(run.village || '대상지 미지정'),
                cycle,
                time: this.normalizeCopy(run.due || run.summary || '시간 미지정'),
                link: run.actionLink || '/missions',
                queryParams: this.actionQueryParams(run),
                toneClass: run.statusType === 'setup' ? 'is-setup' : 'is-scheduled'
            };
            const dates = this.runCalendarDates(run, firstDay, daysInMonth, cycle, index);
            if (!dates.length) {
                unscheduled.push(event);
                return;
            }
            dates.forEach((date) => {
                const key = this.dateKey(date);
                if (!eventsByDate[key]) eventsByDate[key] = [];
                eventsByDate[key].push({ ...event, date: key });
            });
        });

        const days = [];
        for (let index = 0; index < gridLength; index++) {
            const dayNumber = index - leadingBlankDays + 1;
            if (dayNumber < 1 || dayNumber > daysInMonth) {
                days.push({
                    date: '',
                    day: '',
                    isCurrentMonth: false,
                    isToday: false,
                    isEmpty: true,
                    events: [],
                    visibleEvents: [],
                    overflowEvents: [],
                    overflowCount: 0,
                    className: 'is-empty'
                });
                continue;
            }

            const target = new Date(firstDay.getFullYear(), firstDay.getMonth(), dayNumber);
            const key = this.dateKey(target);
            const events = eventsByDate[key] || [];
            const visibleEvents = events.slice(0, 1);
            const overflowEvents = events.slice(1);
            const classes = [];
            if (key === this.dateKey(now)) classes.push('is-today');
            if (events.length) classes.push('has-events');
            days.push({
                date: key,
                day: target.getDate(),
                isCurrentMonth: target.getMonth() === firstDay.getMonth(),
                isToday: key === this.dateKey(now),
                isEmpty: false,
                events,
                visibleEvents,
                overflowEvents,
                overflowCount: overflowEvents.length,
                className: classes.join(' ')
            });
        }

        return {
            monthLabel: this.currentMonthLabel(firstDay),
            caption: '',
            weekdays: ['일', '월', '화', '수', '목', '금', '토'],
            days,
            unscheduled
        };
    }

    private runCalendarDates(run: any, firstDay: Date, daysInMonth: number, cycle: string, index: number) {
        const explicitDates = this.explicitCalendarDates(run, firstDay, daysInMonth);
        if (explicitDates.length) return explicitDates;
        return this.calendarEventDates(firstDay, daysInMonth, cycle, index);
    }

    private explicitCalendarDates(run: any, firstDay: Date, daysInMonth: number) {
        const raw = run && (run.scheduledDates || run.scheduleDates || run.calendarDates || run.scheduledDate || run.date);
        const values = Array.isArray(raw) ? raw : (raw ? [raw] : []);
        const seen: any = {};
        return values.reduce((dates: Date[], value: any) => {
            const parsed = this.parseCalendarDate(value);
            if (!parsed) return dates;
            const sameMonth = parsed.getFullYear() === firstDay.getFullYear() && parsed.getMonth() === firstDay.getMonth();
            const inRange = parsed.getDate() >= 1 && parsed.getDate() <= daysInMonth;
            const key = this.dateKey(parsed);
            if (!sameMonth || !inRange || seen[key]) return dates;
            seen[key] = true;
            dates.push(parsed);
            return dates;
        }, []);
    }

    private parseCalendarDate(value: any) {
        const text = String(value || '').trim();
        const match = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (match) {
            return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
        }
        const parsed = new Date(text);
        if (isNaN(parsed.getTime())) return null;
        return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
    }

    private calendarEventDates(firstDay: Date, daysInMonth: number, cycle: string, index: number) {
        const cycleText = String(cycle || '').trim();
        const dates: Date[] = [];

        if (cycleText === '매주') {
            for (let day = 1 + (index % 7); day <= daysInMonth; day += 7) {
                dates.push(new Date(firstDay.getFullYear(), firstDay.getMonth(), day));
            }
            return dates;
        }

        if (cycleText === '격주') {
            for (let day = 1 + ((index * 3) % 14); day <= daysInMonth; day += 14) {
                dates.push(new Date(firstDay.getFullYear(), firstDay.getMonth(), day));
            }
            return dates;
        }

        if (cycleText === '월 2회') {
            const first = Math.min(daysInMonth, 5 + ((index * 4) % 8));
            const second = Math.min(daysInMonth, first + 14);
            return [
                new Date(firstDay.getFullYear(), firstDay.getMonth(), first),
                new Date(firstDay.getFullYear(), firstDay.getMonth(), second)
            ];
        }

        if (cycleText === '월 1회') {
            const day = Math.min(daysInMonth, 8 + ((index * 5) % 18));
            return [new Date(firstDay.getFullYear(), firstDay.getMonth(), day)];
        }

        return dates;
    }

    private defaultCycleForRun(run: any, index: number) {
        const options = ['매주', '격주', '월 1회', '월 2회'];
        const text = `${run?.code || ''} ${run?.title || ''}`.toLowerCase();
        const seed = text.split('').reduce((total, char) => total + char.charCodeAt(0), index);
        return options[seed % options.length];
    }

    private dateKey(date: Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    private rebuildOverview() {
        this.summaryStats = this.buildSummaryStats(this.patrolRuns);
    }

    private normalizePatrolPage() {
        const count = this.patrolPageCount();
        if (this.patrolPage < 1) this.patrolPage = 1;
        if (this.patrolPage > count) this.patrolPage = count;
    }

    private normalizeTodayPage() {
        const count = this.todayWorkPageCount();
        if (this.todayPage < 1) this.todayPage = 1;
        if (this.todayPage > count) this.todayPage = count;
    }

    private syncPatrolPageSizeToCalendar() {
        const dayCount = this.patrolCalendar && Array.isArray(this.patrolCalendar.days)
            ? this.patrolCalendar.days.length
            : 0;
        const weekRows = dayCount ? Math.ceil(dayCount / 7) : 5;
        this.patrolPageSize = Math.max(1, weekRows);
        this.normalizePatrolPage();
    }

    private isTodayScheduledRun(run: any, index: number) {
        const today = new Date();
        const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
        const daysInMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
        const cycle = this.normalizeCopy(run?.cycle || this.defaultCycleForRun(run, index));
        return this.runCalendarDates(run, firstDay, daysInMonth, cycle, index)
            .some((date) => this.dateKey(date) === this.dateKey(today));
    }

    private isDueTodayRun(run: any) {
        const due = String(run?.due || '').trim();
        return due.indexOf('오늘') >= 0;
    }

    private workNameForStatus(statusType: string) {
        return this.statusLabel(statusType);
    }

    private workTargetForRun(run: any, statusType: string) {
        const title = this.normalizeCopy(run?.title || '');
        const village = this.normalizeCopy(run?.village || '');
        if (statusType === 'assigned' || statusType === 'patrol') {
            return title || village || '대상 미지정';
        }
        if (village && village !== '대상지 미지정') return village;
        return title || '대상 미지정';
    }

    private workSortOrder(statusType: string) {
        if (statusType === 'assigned' || statusType === 'patrol') return 10;
        if (statusType === 'ai' || statusType === 'recapture' || statusType === 'field') return 20;
        if (statusType === 'report') return 30;
        return 90;
    }

    private isActionablePatrolRun(run: any) {
        const statusType = this.normalizeStatusType(run?.statusType || 'assigned');
        const actionLink = String(run?.actionLink || '');
        return ['assigned', 'patrol'].indexOf(statusType) >= 0 && actionLink.indexOf('/missions') === 0;
    }

    private normalizeRuns(runs: any[]) {
        return (Array.isArray(runs) ? runs : []).map((item, index) => {
            const run = item || {};
            const statusType = this.normalizeStatusType(run.statusType || run.type || 'assigned');
            const steps = Array.isArray(run.steps) && run.steps.length ? run.steps : this.defaultSteps(statusType);
            return {
                ...run,
                code: this.normalizeCopy(run.code || `PATROL-${index + 1}`),
                title: this.normalizeCopy(run.title || run.routeName || run.mission || '순찰 이름 미지정'),
                village: this.normalizeCopy(run.village || run.place || '대상지 미지정'),
                owner: this.normalizeCopy(run.owner || run.operator || '담당자 미지정'),
                due: this.normalizeCopy(run.due || run.time || '오늘'),
                statusType,
                statusLabel: this.normalizeCopy(run.statusLabel || run.status || this.statusLabel(statusType)),
                summary: this.normalizeCopy(run.summary || run.nextPointLabel || ''),
                actionLabel: this.normalizeCopy(run.actionLabel || this.actionLabel(statusType)),
                actionLink: run.actionLink || run.link || this.actionLink(statusType),
                toneClass: run.toneClass || this.toneClass(statusType),
                steps: steps.map((step) => this.normalizeStep(step))
            };
        });
    }

    private normalizeStep(step: any) {
        const item = step || {};
        const state = this.normalizeStepState(item.state || item.type || 'waiting');
        return {
            label: this.normalizeCopy(item.label || ''),
            status: this.normalizeCopy(item.status || ''),
            state,
            stateClass: `is-${state}`
        };
    }

    private buildSummaryStats(runs: any[]) {
        const total = runs.length;
        const active = runs.filter((run) => ['assigned', 'patrol'].indexOf(run.statusType) >= 0).length;
        const reportReady = runs.filter((run) => ['report', 'completed'].indexOf(run.statusType) >= 0).length;

        return [
            { label: '운영 대상', value: total, unit: '건', caption: '순찰 건' },
            { label: workflowStatusLabel('assigned'), value: active, unit: '건', caption: '실행 대기' },
            { label: workflowStatusLabel('report'), value: reportReady, unit: '건', caption: '완료 후 정리' }
        ];
    }

    private buildRunsFromLegacy(data: any) {
        const targets = Array.isArray(data.patrolTargets) ? data.patrolTargets : [];
        const tasks = Array.isArray(data.priorityTasks) ? data.priorityTasks : [];
        const taskRuns = tasks.slice(0, 5).map((task, index) => {
            const action = this.primaryAction(task);
            const statusType = this.statusTypeFromText(`${task.route || ''} ${task.title || ''} ${task.summary || ''} ${action.link || ''}`);
            return {
                code: task.code || `CHECK-${index + 1}`,
                title: task.title || '운영 확인',
                village: task.route || '운영 현황',
                owner: task.owner || task.department || '운영 담당자',
                statusType,
                statusLabel: task.summary || this.statusLabel(statusType),
                summary: task.due || '',
                actionLabel: action.label || this.actionLabel(statusType),
                actionLink: action.link || this.actionLink(statusType)
            };
        });

        if (targets.length) {
            const targetRuns = targets.map((target, index) => ({
                code: target.code || `MIS-${index + 1}`,
                missionCode: target.missionCode || '',
                templateId: target.templateId || '',
                title: target.mission || target.title || '순찰 이름 미지정',
                village: target.place || target.village || '대상지 미지정',
                owner: target.owner || target.operator || '담당자 미지정',
                due: target.time || '오늘 수행',
                statusType: 'assigned',
                statusLabel: target.status || workflowStatusLabel('assigned'),
                summary: target.summary || '촬영 대기',
                actionLabel: '순찰 실행',
                actionLink: '/missions'
            }));
            const nonMissionTasks = taskRuns.filter((run) => String(run.actionLink || '').indexOf('/missions') !== 0);
            return [...targetRuns, ...nonMissionTasks];
        }

        return taskRuns;
    }

    private primaryAction(task: any) {
        const actions = task && Array.isArray(task.actions) ? task.actions : [];
        return actions.find((action) => action && action.primary) || actions[0] || {};
    }

    private statusTypeFromText(text: string) {
        if (text.indexOf('/ai-review') >= 0 || text.indexOf('AI') >= 0) return 'ai';
        if (text.indexOf('/reports') >= 0 || text.indexOf('보고') >= 0) return 'report';
        if (text.indexOf('/missions') >= 0 || text.indexOf('실행') >= 0 || text.indexOf('배정') >= 0) return 'assigned';
        return 'setup';
    }

    private normalizeStatusType(value: any) {
        const text = String(value || '').toLowerCase();
        if (['setup', 'assigned', 'patrol', 'ai', 'recapture', 'field', 'report', 'completed'].indexOf(text) >= 0) return text;
        return 'assigned';
    }

    private normalizeStepState(value: any) {
        const text = String(value || '').toLowerCase();
        if (['done', 'current', 'warning', 'waiting'].indexOf(text) >= 0) return text;
        return 'waiting';
    }

    private defaultSteps(statusType: string) {
        if (statusType === 'setup') {
            return [
                { label: '설정', status: workflowStatusLabel('setup'), state: 'warning' },
                { label: '순찰', status: workflowStatusLabel('assigned'), state: 'waiting' },
                { label: 'AI', status: workflowStatusLabel('ai'), state: 'waiting' },
                { label: '보고', status: workflowStatusLabel('report'), state: 'waiting' }
            ];
        }
        if (statusType === 'assigned' || statusType === 'patrol') {
            return [
                { label: '순찰', status: workflowStatusLabel(statusType), state: 'current' },
                { label: '완료', status: workflowStatusLabel('patrolCompleted'), state: 'waiting' },
                { label: 'AI', status: workflowStatusLabel('ai'), state: 'waiting' },
                { label: '보고', status: workflowStatusLabel('report'), state: 'waiting' }
            ];
        }
        if (statusType === 'ai' || statusType === 'recapture' || statusType === 'field') {
            return [
                { label: '순찰', status: workflowStatusLabel('patrolCompleted'), state: 'done' },
                { label: 'AI', status: workflowStatusLabel(statusType), state: 'warning' },
                { label: '보고', status: workflowStatusLabel('report'), state: 'waiting' },
                { label: '생성', status: workflowStatusLabel('reportGenerated'), state: 'waiting' }
            ];
        }
        return [
            { label: '순찰', status: workflowStatusLabel('patrolCompleted'), state: 'done' },
            { label: 'AI', status: workflowStatusLabel('ai'), state: 'done' },
            { label: '보고', status: workflowStatusLabel(statusType), state: statusType === 'completed' ? 'done' : 'current' },
            { label: '생성', status: workflowStatusLabel('reportGenerated'), state: statusType === 'completed' ? 'done' : 'waiting' }
        ];
    }

    private statusLabel(statusType: string) {
        return workflowStatusLabel(statusType);
    }

    private actionLabel(statusType: string) {
        if (statusType === 'setup') return '준비 확인';
        if (statusType === 'ai' || statusType === 'recapture' || statusType === 'field') return 'AI 확인';
        if (statusType === 'report' || statusType === 'completed') return '보고 확인';
        return '순찰 실행';
    }

    private actionLink(statusType: string) {
        if (statusType === 'setup') return '/villages';
        if (statusType === 'ai' || statusType === 'recapture' || statusType === 'field') return '/ai-review';
        if (statusType === 'report' || statusType === 'completed') return '/reports';
        return '/missions';
    }

    public actionQueryParams(run: any) {
        if (!run) return {};
        const actionLink = String(run.actionLink || '');
        const isMissionLink = actionLink.indexOf('/missions') === 0;
        const isAiReviewLink = actionLink.indexOf('/ai-review') === 0;
        if (!isMissionLink && !isAiReviewLink) return {};
        const params: any = {};
        if (run.code) {
            if (isAiReviewLink && ['ai', 'recapture', 'field'].indexOf(String(run.statusType || '')) >= 0 && String(run.code).indexOf('AI') === 0) {
                params.case = run.code;
            } else {
                params.mission = run.code;
            }
        }
        if (run.runId) params.runId = run.runId;
        if (run.missionCode) params.missionCode = run.missionCode;
        if (run.templateId) params.templateId = run.templateId;
        return params;
    }

    private toneClass(statusType: string) {
        return workflowStatusCssClass(statusType);
    }

    private normalizeCopy(value: any) {
        return String(value || '')
            .replace(/AI 판정/g, 'AI 확인')
            .replace(/판정하기/g, 'AI 확인')
            .replace(/미처리 AI 판정/g, workflowStatusLabel('ai'))
            .replace(/AI 확인 대기/g, workflowStatusLabel('ai'))
            .replace(/확인 대기/g, workflowStatusLabel('ai'))
            .replace(/순찰 배정됨/g, workflowStatusLabel('assigned'))
            .replace(/^배정됨$/g, workflowStatusLabel('assigned'))
            .replace(/보고 준비/g, workflowStatusLabel('report'))
            .replace(/생성 전/g, workflowStatusLabel('report'))
            .replace(/생성 완료/g, workflowStatusLabel('reportGenerated'))
            .replace(/운영 보고/g, '보고서 작성')
            .replace(/보고 확인/g, '보고 확인')
            .replace(/첫 순찰 기준 작성/g, '순찰 정보 등록')
            .replace(/순찰 기준 배포 상태 확인/g, '순찰 준비 상태 확인')
            .replace(/^보고$/g, '보고서 작성');
    }

    public renderNow() {
        try {
            this.ref.detectChanges();
        } catch (error) { }
    }
}

export default PageDashboardComponent;